import IcPrev from '../../assets/image/ic_arrow_left.svg';

interface TopHeaderWithPrevProps {
  title?: string;
  onClickPrev?: () => void;
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties | null;
  icon?: string | null;
}

export default function TopHeaderWithPrev({
  title = '',
  onClickPrev = () => {},
  style = {},
  titleStyle = null,
  icon = null,
}: TopHeaderWithPrevProps) {
  return (
    <div
      className="h-[48px] flex justify-center items-center w-full bg-white px-[20px] flex-grow-0 flex-shrink-0"
      style={{
        ...style,
      }}
    >
      <button type="button" className="w-[24px] h-[24px] cursor-pointer" onClick={onClickPrev}>
        <img src={icon ? icon : IcPrev} alt="back" />
      </button>
      <div
        className="text-[18px] leading-[19px] font-[700] text-[#2D2D2D] text-center flex-grow flex-shrink-1"
        style={titleStyle ? titleStyle : {}}
      >
        {title}
      </div>
      <div className="w-[24px] h-[24px]" style={{ visibility: 'hidden' }} />
    </div>
  );
}

